<template>
    <div class="ad" v-if="isActive">
        <a v-if="getUrl" :href="getUrl">
            <img class="img-fluid" :src="getImage"/>
        </a>
        <div v-else>
            <img class="img-fluid" :src="getImage"/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Ad',
    props: {
        name: {
            require: true
        },
    },
    computed: {
        isActive() {
            return this.$root.whitelabel.setting(this.name) !== undefined ? JSON.parse(this.$root.whitelabel.setting(this.name)) : false
        },
        getImage() {
            return this.$root.whitelabel.setting(`${this.name}_image`)
        },
        getUrl() {
            return this.$root.whitelabel.setting(`${this.name}_url`) ?? ''
        }
    },
}
</script>
